module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Angels’ Wings")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Like a coming death, ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("waves of tiredness")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("sweep though mind, body, soul.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Emptiness? Burn-out? ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Breakdown? ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("A river that’s run")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("dry?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Bran tub of the restless mind,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("unlucky dip!")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Non-stop worthies that make me tick")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("drain me, give little back,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("task on task, info without end,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("twittering lords of night and day –")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("dumb, blind, ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("don’t get what I’m at.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Now ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the sinkhole of my fears,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("opens up")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("lets slip the jackals, demons")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of the soul:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Old-age fearful of the flow of time;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("imagined lovers that were never mine! ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("Unraveling of the body ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("that can’t be stopped;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("the card-house fragile ego ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("craving recognition I never got. ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("“All my good times they are gone, ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("it’s time for movin’ on” -")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("No heart, no wellspring.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Just hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Disconnected and alone,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I let go, ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("heave the dead weight of nothings")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("overboard.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Ship now lightened journeys on.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Sails, full and gold as angels’ wings,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("catch the winds of God. ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Provisioned with such gifts of love,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I want for nothing, come alive.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Abled now to give, not fearful, ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I know myself again:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("a heart wrenched open")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("able to respond.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10025939","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-8.vue
// module id = 81
// module chunks = 0